// src/content/marineCards.ts — 10 Marine Ecology Field Cards Configuration
// Traces to Story 2.2, FR-ENG-001, FR-ENG-002, UI Redesign Field Cards

export interface MarineCardConfig {
  id: number;
  title: string;
  subtitle: string;
  image: string;
  webpImage: string;
  glowColor: string;
  passageId: string;
}

export const marineCards: MarineCardConfig[] = [
  {
    id: 1,
    title: 'Card 1',
    subtitle: 'Lobster',
    image: '/assets/cards/card-1-lobster.png',
    webpImage: '/assets/cards/card-1-lobster.webp',
    glowColor: '#00E5FF', // Neon Cyan
    passageId: 'passage-01-lobster-claws',
  },
  {
    id: 2,
    title: 'Card 2',
    subtitle: 'Mantis Shrimp',
    image: '/assets/cards/card-2-mantis-shrimp.png',
    webpImage: '/assets/cards/card-2-mantis-shrimp.webp',
    glowColor: '#FF4D6D', // Neon Coral / Crimson
    passageId: 'passage-02-mantis-shrimp',
  },
  {
    id: 3,
    title: 'Card 3',
    subtitle: 'Flashlight',
    image: '/assets/cards/card-3-flashlight.png',
    webpImage: '/assets/cards/card-3-flashlight.webp',
    glowColor: '#FFE066', // Golden Yellow
    passageId: 'passage-03-bioluminescent-lanterns',
  },
  {
    id: 4,
    title: 'Card 4',
    subtitle: 'Shell',
    image: '/assets/cards/card-4-shell.png',
    webpImage: '/assets/cards/card-4-shell.webp',
    glowColor: '#B8C0FF', // Lavender Periwinkle
    passageId: 'passage-04-hermit-crab-cooperation',
  },
  {
    id: 5,
    title: 'Card 5',
    subtitle: 'Crab',
    image: '/assets/cards/card-5-crab.png',
    webpImage: '/assets/cards/card-5-crab.webp',
    glowColor: '#FF70A6', // Hot Neon Pink
    passageId: 'passage-05-fiddler-crab-wave',
  },
  {
    id: 6,
    title: 'Card 6',
    subtitle: 'Squid',
    image: '/assets/cards/card-6-squid.png',
    webpImage: '/assets/cards/card-6-squid.webp',
    glowColor: '#C77DFF', // Neon Abyssal Violet
    passageId: 'passage-06-cuttlefish-camouflage',
  },
  {
    id: 7,
    title: 'Card 7',
    subtitle: 'Sea Spider',
    image: '/assets/cards/card-7-sea-spider.png',
    webpImage: '/assets/cards/card-7-sea-spider.webp',
    glowColor: '#38BDF8', // Electric Blue
    passageId: 'passage-07-spider-crab-armor',
  },
  {
    id: 8,
    title: 'Card 8',
    subtitle: 'Shrimp',
    image: '/assets/cards/card-8-shrimp.png',
    webpImage: '/assets/cards/card-8-shrimp.webp',
    glowColor: '#FB923C', // Flame Orange
    passageId: 'passage-08-cleaner-shrimp-station',
  },
  {
    id: 9,
    title: 'Card 9',
    subtitle: 'Fossil',
    image: '/assets/cards/card-9-fossil.png',
    webpImage: '/assets/cards/card-9-fossil.webp',
    glowColor: '#2DD4BF', // Bioluminescent Teal
    passageId: 'passage-09-nautilus-buoyancy',
  },
  {
    id: 10,
    title: 'Card 10',
    subtitle: 'Rock',
    image: '/assets/cards/card-10-rock.png',
    webpImage: '/assets/cards/card-10-rock.webp',
    glowColor: '#94A3B8', // Volcanic Slate
    passageId: 'passage-10-barnacle-glue',
  },
];
